import TableSetting from './TableSetting'

export default TableSetting
